import * as React from 'react';
import { Search, useNavigate } from 'react-router-dom';
import * as Models from '../models/index';
import { useContext, useEffect, useReducer } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Button, Col, FormGroup, Row, Spinner } from 'reactstrap';
import { formatDate } from '../utils';
import { Formik, FormikErrors, FormikProps, FormikValues } from 'formik';
import * as FormUtils from '../components/formUtils/index';
import { AccountService, SearchIn } from '../services/AccountService';
import AuthenticationContext from '../components/context/AuthenticationContext';
import { ELPEditor } from '../components/editors/ELPEditor';
import UserProfileService from '../services/UserProfileService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

type UserState = {
    user: Models.UserProfile,
}

export const ELPEdit = (props: {

}) => {

    const authCtx = useContext(AuthenticationContext);

    let [state, setState] = useReducer(
        (prevState: UserState, newState: Partial<UserState>) => ({ ...prevState, ...newState }),
        {
            user: new Models.UserProfile()
        }
    );

    const getUser = async () => {

        const userProfileId = window.location.href.substr(window.location.href.lastIndexOf("/") + 1);

        if (userProfileId) {
            const user = await UserProfileService.get(userProfileId as string);

            if (!user.hasErrors) {
                setState({
                    user: user.value
                })
            }


        }
    }

    useEffect(() => {
        getUser();
    }, []);

    return <div>
        <h1>English Language Proficiency Edit</h1> 

        <h5>{state.user.surname} {state.user.givenNames}, {state.user.dateOfBirth != null && formatDate(state.user.dateOfBirth as Date)}
        </h5>
        <a href={'mailto:' + state.user.email1}><FontAwesomeIcon icon={solid("envelope")} className="me-2" />{state.user.email1}</a>
        <a href={'tel:' + state.user.telephone} className="ms-4"><FontAwesomeIcon icon={solid("phone")} className="me-2" />{state.user.telephone}</a>

        <ELPEditor />
    </div>
};